module["exports"] = [
  "#{city_prefix}#{city_suffix}",
  "#{city_prefix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/city.js
// module id = 822
// module chunks = 0